import { IFiltrosLote } from "../interfaces/IFiltrosLote";
import { IOrdenacao } from "../interfaces/IOrdenacao";

export const FILTROS_LOTE_VAZIOS: IFiltrosLote = {
  pdi: "",
  idLote: [],
  prensa: null,
  statusAutorizacao: null,
  statusProducao: null,
  idUsuario: null,
  placa: "",
  periodoCriacao: null,
};

export const ORDENACAO_LOTE_PADRAO: IOrdenacao = {
  campo: "criadoEm",
  direcao: "DESC",
};
